import { createIcon } from '@chakra-ui/icons';

export const Pdf = createIcon({
  displayName: 'Pdf',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3856 0.666672C6.8552 0.666672 6.34648 0.877385 5.97141 1.25246L2.58579 4.63808C2.21071 5.01315 2 5.52186 2 6.05229V8.00001H14V2.66667C14 1.56211 13.1046 0.666672 12 0.666672H7.3856ZM7.33333 6.00001H3.33333L7.33333 2.00001V6.00001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666748 9.33334H3.00008C4.28875 9.33334 5.33341 10.378 5.33341 11.6667C5.33341 12.9553 4.28875 14 3.00008 14H2.00008V15.3333H0.666748V9.33334ZM2.00008 12.6667H3.00008C3.55237 12.6667 4.00008 12.2189 4.00008 11.6667C4.00008 11.1144 3.55237 10.6667 3.00008 10.6667H2.00008V12.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 9.33334H7.66667C9.32353 9.33334 10.6667 10.6765 10.6667 12.3333C10.6667 13.9902 9.32353 15.3333 7.66667 15.3333H6V9.33334ZM7.33333 10.6667V14H7.66667C8.58713 14 9.33333 13.2538 9.33333 12.3333C9.33333 11.4129 8.58713 10.6667 7.66667 10.6667H7.33333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3333 9.33334H15.3333V10.6667H12.6666V11.6667H14.6666V13H12.6666V15.3333H11.3333V9.33334Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
